import React from "react";

const CancelledCalendar = (props: any) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.3335 1.33398V3.33398"
        stroke="var(--color-txt-primary)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6665 1.33398V3.33398"
        stroke="var(--color-txt-primary)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.3335 6.06055H13.6668"
        stroke="var(--color-txt-primary)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 5.66732V11.334C14 13.334 13 14.6673 10.6667 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V5.66732C2 3.66732 3 2.33398 5.33333 2.33398H10.6667C13 2.33398 14 3.66732 14 5.66732Z"
        stroke="var(--color-txt-primary)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.463 9.13411H10.469"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.463 11.1341H10.469"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99715 9.13411H8.00314"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99715 11.1341H8.00314"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52938 9.13411H5.53537"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52938 11.1341H5.53537"
        stroke="var(--color-txt-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CancelledCalendar;
